export const SET_DIMENSIONS = 'SET_DIMENSIONS'